
import { Enums } from '@bode-canada/core';
import PercentMatch from '@/components/listings/PercentMatch';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { FrontendMarkForListingStatus } from '@/constants/listing';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

const { ListingStatusEnum, ListingOriginEnum } = Enums;

export default {
  name: 'NewOfferComponent',
  components: {
    Icon,
    PercentMatch,
  },
  props: {
    listing: {
      type: Object,
      default: () => {},
    },
    imageAction: {
      type: Object,
      default: null,
    },
    isSold: {
      type: Boolean,
      default: false,
    },
    isShowBodeExclusive: {
      default: false,
      type: Boolean,
    },
    isShowStatusInfo: {
      default: false,
      type: Boolean,
    },
    isHideChip: {
      default: false,
      type: Boolean,
    },
    isMyListings: {
      default: false,
      type: Boolean,
    },
    isSoldPinShown: {
      default: true,
      type: Boolean,
    },
    isProfile: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    IconType,
    PercentMatch,
  }),
  computed: {
    isProfileAndStatusPending() {
      const { status } = this.listing;

      return status === ListingStatusEnum.PENDING && this.isProfile;
    },
    listingStatusInfo() {
      const { status, isHidden } = this.listing;

      if (this.isProfileAndStatusPending) {
        return FrontendMarkForListingStatus.Active;
      }

      if (status === ListingStatusEnum.HIDDEN || isHidden) {
        return FrontendMarkForListingStatus.Inactive;
      }

      if (status === ListingStatusEnum.PENDING) {
        return FrontendMarkForListingStatus.UnderReview;
      }

      if (status === ListingStatusEnum.NEW && this.isMyListings) {
        return FrontendMarkForListingStatus.UnderReview;
      }

      if (status === ListingStatusEnum.SOLD) {
        return FrontendMarkForListingStatus.Sold;
      }

      return status;
    },
    image() {
      return this.listing.image?.lowResUrl;
    },
    chipTitle() {
      let title = this.listingStatusInfo;
      if (this.isBode && this.isSold && !this.isShowStatusInfo) {
        title = 'Bōde Listing';
      } else if (this.showBodeExclusive) {
        title = 'Bōde Exclusive';
      } else if (this.showMLSLabel) {
        title = 'Agent Listing';
      }

      return title;
    },
    chipIcon() {
      let icon = null;
      if (this.showBodeExclusive) {
        icon = IconType.BodePin;
      }

      return icon;
    },
    chipColorSchema() {
      const colorSchemaByIcon = {
        [IconType.SoldListingPin]: StyleColorSchemeType.SuccessDark,
        [IconType.BodePin]: StyleColorSchemeType.Secondary,
      };
      return colorSchemaByIcon[this.chipIcon];
    },
    isBode() {
      return this.listing.origin === ListingOriginEnum.BODE;
    },
    showBodeExclusive() {
      return this.isBode && !this.isSold && this.isShowBodeExclusive;
    },
    showMLSLabel() {
      return !this.isBode
        && !this.isSold
        && !this.isMyListings
        && !this.showStatusInfo;
    },
    showStatusInfo() {
      return !this.isSold && !this.isShowBodeExclusive && this.listingStatusInfo;
    },
    chipClassNames() {
      return new StyleClassNamesBuilder('chip')
        .addConditionClassName('sold', this.isSold && !this.isShowStatusInfo)
        .build();
    },
  },
};
